<script>
import {authHeader} from '../../../_helpers'
import axios from 'axios'

export default {
  name: "ReportsMixin",
  props: {
    reportId: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      customerHeaders:
          [
            {
              text: 'Код',
              align: 'left',
              sortable: true,
              value: 'code'
            },
            {text: 'Пол', value: 'sex', align: 'left', sortable: true},
            {text: 'Телефон', value: 'phone', align: 'left', sortable: true},
            {text: 'Запрос', value: 'hint', align: 'left', sortable: true},
            {text: 'Действия', value: 'role', align: 'left', sortable: false}
          ],
      customerHeadersExtended:
          [
            {
              text: 'Код',
              align: 'left',
              sortable: true,
              value: 'code'
            },
            {text: 'Пол', value: 'sex', align: 'left', sortable: true},
            {text: 'Телефон', value: 'phone', align: 'left', sortable: true},
            {text: 'Запрос', value: 'hint', align: 'left', sortable: true},
            {text: 'Действия', value: 'role', align: 'left', sortable: false}
          ],
      customers: [],
      selectedProducts: [],
      selectedConsultings: [],
      selectedTests: [],
      alertProducts: false,
      alertConsulting: false,
      alertCustomers: false,
      notificationText: 'Отчет успешно сохранен',
      dialogText: 'Отчет успешно сохранен',
      submitError: false,
      dialogReportDuplicate: false,
      dialogBodyText: 'Загружаются данные отчета',
      dialogSubmit: false,
      dialogErrorSubmit: false,
      dialogEmptyReport: false,
      errorList: [],
      formHasErrors: false,
      date: this.todayDate(),
      isPageDisabled: false,
      savedData: null,
      hours: 0,
      dialogLoading: false,
      errorMessages: '',
      duplicateCnt: 0,
      errorType: null,
      productsListSelected: [],
      consultListSelected: [],
      testsListSelected: [],
      directionsListSelected: [],
      customerGroupsListSelected: [],
      error: {},
      reportTypes: {
        'lgbtq': 'ЛГБТКИ+',
        'outreach': 'Аутрич',
        'casemanagement': 'КМ',
        'seminar': 'Семинар',
        'psych': 'Пcихолог',
        'lawyers': 'Юристы'
      }
    }
  },
  computed: {
    isOutreach () {
      return this.reportType === 'outreach'
    },
    sessionStorageName () {
      return this.reportType
      // return this.isOutreach ? "outreachReport" : "caseReport"
    },
    // form () {
    //   return {}
    // },
    productsListFiltered () {
      let res = this.productsList ? this.productsList.filter(p => {
        if ('producttype' in p && p.producttype !== null) return [3, 1].indexOf(p.producttype.id) > -1 &&
            (p.report_type.indexOf(this.productsRights) > -1)
      }) : []
      return res
    },
    productsListItems () {
      let items = this.productsListFiltered.map(p => ({'text':p.name,'additionalName':p.additional_name,'value':p.id,'name':p.name,'id':p.id}))
      this.productsListSelected = items.slice(0,10).map(p => p.value)
      return items
    },
    testsListFiltered () {
      let items = this.productsList ? this.productsList.filter(p => {
        if ('producttype' in p && p.producttype !== null) return p.producttype.id===4 && (p.report_type.indexOf(this.productsRights) > -1)
      }) : []
      return items
    },
    testsListItems () {
      let items = this.testsListFiltered.map(p => ({'text':p.name,'additionalName':p.additional_name,'value':p.id,'id':p.id,'name':p.name,'additional':p.additional}))
      this.testsListSelected = items.slice(0,10).map(p => p.id)
      return items
    },
    consultListFiltered () {
      return this.productsList.filter(p => {
        if ('producttype' in p && p.producttype !== null) return (p.producttype.id === 2 && p.report_type.indexOf(this.productsRights) > -1)
      })
    },
    consultListCaseFiltered () {
      return this.productsList.filter(p => {
        if ('producttype' in p && p.producttype !== null) return (p.producttype.id === 2 && (p.report_type.indexOf(this.productsRights) > -1))
      })
    },
    consultListItems () {
      let items = this.consultListFiltered.map(p => ({'text':p.name,'value':p.id,'name':p.name,'id':p.id}))
      this.consultListSelected = items.slice(0,10).map(p => p.value)
      return items
    },
    customerGroupsListItems () {
      let items = this.customerGroupsList.map(p => ({'deleted':false,'name':p.name,'id':p.id}))
      this.customerGroupsListSelected = items.slice(0,10).map(p => p.value)
      return items
    },
    formDisabled () {
      return Object.entries(this.form).filter(p => {
        return (p[0] !== 'volunteer' && p[0] !== 'customers')
      }).some(x => (x[1] === null || x[1] ===
          '' || x[1] !== undefined && x[1].length === 0))
    },
    url () {
      return this.reportId ? this.reportsUrl + '/' + this.reportId : this.reportsUrl
    },
    reportType () {
      return this.$route.meta.reportType
    },
    productsRights () {
      return this.reportTypes[this.reportType]
    },
    reportClasses () {
      let header = this.isPageDisabled ? 'read-only-header' : this.reportType
      return [header]
    },
    reportsUrl () {
      return this.$store.state.tableData.backend + '/api/reports/' + this.reportType
    },
    submitForm () {
      let form = this.form
      form['descLetter'] = this.descLetter
      form['volunteer'] = this.volunteer
      form['date']=this.date
      return form
    }
  },
  watch: {
    reportId (newValue) {
      newValue === null ? this.clearReport() : newValue
    },
    form (newValue) {
      sessionStorage.setItem(this.sessionStorageName, JSON.stringify(newValue))
    },
    savedData (data) {
      let rep = data.report
      if  (rep) {
        this.selectedUsers = rep.users ? rep.type === "casemanagements" ? rep.users[0]:rep.users : []
        this.date = data.report['date'] ? data.report['date']: this.firstDayOfTheWeek()
        this.hours = rep.hours ? rep.hours : 0
        this.selectedPlaces = rep.place ? rep.place.constructor ===Object ? rep.place['id'] :rep.place : null
        this.descLetter = rep.other ? rep.other : null
        this.volunteer = rep.volunteer ? rep.volunteer : null
        // this.selectedPlaces = data.report['selectedPlaces']
        this.selectedProducts = data.selectedProducts
        this.selectedConsultings = data.selectedConsultings
        this.selectedTests = data.selectedTests
        this.customers = data.customers
      }

    }
  },

  methods: {
    onGenerateCodes (data) {
      data['customers'] = this.customers
      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      }
      let vm = this
       axios({
        method: 'post',
        url:  vm.reportsUrl + '/generate_codes',
        headers: requestOptions['headers'],
        data: data

      }).then((resp) => {
        this.customers = resp.data
        this.$emit('updateCustomers', this.customers)

      }).catch(() => {
        throw new Error(`You can't load the data`)
      })
        },
    onMount () {
      let report

      if (this.reportId !== null) {
        this.customerHeaders = this.customerHeadersExtended
        let vm = this
        const requestOptions = {
          method: 'GET',
          headers: authHeader()
        }
        axios({
          method: 'get',
          url: this.url,
          headers: requestOptions['headers']
        }).then((response) => {
          report = response.data
          if (vm.customers.length === 0) {
            report.customers.forEach(function (c) {
              vm.customers.push({
                full_code: c.customer.full_code, sex: c.customer.sex, phone: c.phone, hint: c.hint,
                products: report["products"][c.customer.full_code] ? report["products"][c.customer.full_code].filter(pr => pr.producttype!==2) : [],
                consultings:report["products"][c.customer.full_code] ? report["products"][c.customer.full_code].filter(pr => pr.producttype===2) : [],
                tests:report["products"][c.customer.full_code] ? report["products"][c.customer.full_code].filter(pr => pr.producttype===4 || pr.producttype===3) : [],
              })
            })

            if (report.customers.length===0) {
              vm.selectedProducts = report.products ? report.products.filter(pr => pr.producttype!==2 || pr.producttype!==4) : []
              vm.selectedConsultings = report.products ? report.products.filter(pr => pr.producttype===2) : []
              vm.selectedTests = report.products ? report.products.filter(pr => pr.producttype===4) : []
              }
          }
          this.savedData = {
            'report': report,
            'selectedProducts': vm.selectedProducts,
            'selectedConsultings': vm.selectedConsultings,
            'selectedTests': vm.selectedTests,
            'users': vm.selectedUsers,
            'customers': vm.customers,
            'other': vm.other,
            'volunteer': vm.volunteer,
            'date': vm.date,
            'hours': vm.hours
          }
        }).catch((error) => {
          vm.loading = false
          throw new Error(error)
        })
      } else {
        this.customerHeaders = this.customerHeadersExtended
        report = JSON.parse(sessionStorage.getItem(this.sessionStorageName))
        if (report) {
          let vm = this
          if ('products' in report) {
          report.products.forEach(function (p, i) {
            let val = {
              name: p.name ? p.name : p.product.name,
              amount: p.amount,
              additional: p.additional,
              id: p.id
            }
            vm.$set(vm.selectedProducts, i, val)
          })
        }
        if ('customers' in report) {

          report.customers.forEach(function (c) {
            vm.customers.push({
              full_code: c.full_code, sex: c.sex, phone: c.phone, hint: c.hint
            })
          })
        }
          if ('consultings' in report) {

            report.consultings.forEach(function (p) {
              vm.selectedConsultings.push({
                name: p.name ? p.name : p.product.name,
                amount: p.amount,
                additional: p.additional,
                id: p.id
              })
            })
          }
          this.savedData = {
            'report': report,
            'selectedProducts': vm.selectedProducts,
            'selectedConsultings': vm.selectedConsultings,
            'selectedTests': vm.selectedTests,
            'customers': vm.customers,
            'users': vm.selectedUsers,
            'other': vm.other,
            'volunteer': vm.volunteer,
            'date': vm.date,
            'hours': vm.hours
          }
        }
      }
      return {
        'report': report,
        'selectedProducts': this.selectedProducts,
        'selectedConsultings': this.selectedConsultings,
        'customers': this.customers
      }
    },
    submitRequest () {
      let vm = this
      // this.submitForm = vm.form
      // this.submitForm['customers'] = 'customers' in this.submitForm && this.submitForm['customers'].length === 0 ? this.$refs['indicators'].$refs['customers'].tableDataExternal : null
      this.dialoLoading = true
      // this.submitForm['descLetter'] = vm.descLetter
      // this.submitForm['volunteer'] = vm.volunteer
      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      }
      axios({
        method: vm.reportId ? 'put' : 'post',
        url: vm.url,
        headers: requestOptions['headers'],
        data: vm.submitForm

      }).then(() => {
        vm.alert = true
        vm.dialogEmptyReport = false
        vm.submitError = false
        vm.dialoLoading = false
        vm.dialogSubmit = true
        vm.alertColor = 'green'
        vm.notificationText = 'Отчет успешно сохранен!'
        sessionStorage.setItem(vm.sessionStorageName, null)
        vm.isPageDisabled = true

      }).catch(() => {
        sessionStorage.setItem(vm.sessionStorageName, null)
        vm.dialoLoading = false
        vm.dialogEmptyReport = false
        vm.dialogErrorSubmit = true
        vm.alertColor = 'red'
        vm.alert = true
        vm.notificationText = 'Что-то пошло не так!'
        vm.submitError = true
        vm.isPageDisabled = false
        throw new Error(`You can't load the data`)
      })
    },
    checkDuplicates () {
      this.dialogEmptyReport = false
      let vm = this
      const requestOptions = {
        method: 'POST',
        headers: authHeader()
      }
       async function asyncFunc (vm) {
        // fetch data from a url endpoint
        try {
          const response = await axios({
            method: 'post',
            url: vm.reportsUrl + '/check_report',
            headers: requestOptions['headers'],
            data: vm.submitForm
          })
          const data = await response
            if (data.status === 200)
                if (data.data === 'OK') {
                  vm.submitRequest()
                }
              else {
                  vm.duplicateCnt = data.data['amount']
                  vm.errorType =  data.data['error']
                  vm.error =  data.data
                  vm.dialogReportDuplicate = true
                }
            return data.status
        } catch (error) {
          vm.dialogReportDuplicate = error.message.indexOf('409') > -1
          vm.loading = false
        }
      }
      if (!this.reportId) {
        asyncFunc(vm)
      }
      else {
        vm.submitRequest()
      }
    },
    submitReport () {
      this.errorList = []
      this.formHasErrors = false
      this.dialogText = 'Сохраняются данные отчета'
      let vm = this
      if (this.isOutreach) {
        vm.form['descLetter'] = vm.descLetter
        this.formHasErrors = (vm.selectedProducts.length === 0 || vm.selectedUsers.length
            === 0 || vm.selectedConsultings.length === 0)
        this.alertProducts = vm.selectedProducts.length === 0
        this.alertConsulting = vm.selectedConsultings.length === 0

        if (this.formHasErrors) {
          Object.keys(vm.form).forEach(f => {
            let el = ['consultings', 'products', 'customers'].indexOf(f) > -1 ? vm.$refs.indicators.$refs[f] : vm.$refs[f]
            let ref = el.valid === 'undefinded' ? el.$children[0] : el
            ref = ['place', 'users', 'descLetter'].indexOf(f) > -1 ? vm.$refs[f].$children[0] : ref
            ref = f === 'date' ? vm.$refs[f].$children[0].$children[0] : ref
            if (!ref.valid) {
              if (ref.label) this.errorList.push(ref.label)
            }

          })
          if (this.alertProducts)
            this.errorList.push('Материалы')
          if (this.alertConsulting)
            this.errorList.push('Консультации')
          if (this.alertCustomers)
            this.errorList.push('Участники')
          if (this.descLetter === '' || this.descLetter === null)
            this.errorList.push('Письмо с описанием выхода')
          this.dialogEmptyReport = true
        }
      }
      if (!this.formHasErrors) {
        const requestOptions = {
          method: 'GET',
          headers: authHeader()
        }

        if (!this.reportId) {
          this.checkDuplicates()
        } else vm.submitRequest()
      }
    },
    dateUpdated (newVal) {
      this.date = newVal
    },
    cancelReport () {
      this.$router.push({name: 'ReportsList'})
    },
    toReports () {
      this.$router.push({name: 'ReportsList'})
    },
    //   printQR () {
    //     this.$refs['qrCodeElement'].printQR(this.customers)
    //     this.dialogSubmit = false
    //     this.dialogReportDuplicate = false
    //   },
    //
    addDuplicate () {
      this.dialogReportDuplicate = false
      this.submitRequest()
    },

    deleteProductsList (newVal) {
      this.selectedProducts.splice(newVal, 1)

    },
    deleteConsultingList (newVal) {
      this.selectedConsultings.splice(newVal, 1)
    },
    deleteCustomersList (newVal) {
      this.customers.splice(newVal, 1)
    },

    onUpdateProductsList (newVal) {
      let vm = this
      newVal.forEach(function (v, i) {
        vm.$set(vm.selectedProducts, i, v)
      })
      this.$emit('updateProducts', newVal)
    },
    onUpdateConsultingList (newVal) {
      let vm = this
      newVal.forEach(function (v, i) {
        vm.$set(vm.selectedConsultings, i, v)
      })
      this.$emit('updateConsultings', newVal)
    },
    onUpdateTestsList (newVal) {
      let vm = this
      newVal.forEach(function (v, i) {
        vm.$set(vm.selectedTests, i, v)
      })
      this.$emit('updateConsultings', newVal)
    },
    onClearCustomers () {
      this.customers = []
    },
    onUpdateCustomersList (newVal, index) {
      let vm = this
      let customers = vm.customers
      if (index !== null) {
        newVal.forEach(val => Object.assign(this.customers[index], val))
      } else {
        let exists = false
        if (!exists) {
          newVal.forEach(val =>
              customers.push({
                'full_code': val['full_code'].toUpperCase(),
                'sex': val['full_code'].toUpperCase().slice(-1),
                'phone': val['phone'],
                'hint': val['hint']
              }))
          customers.forEach(function (v, i) {
            vm.$set(vm.customers, i, v)
          })

        }
      }
      this.$emit('updateCustomers', customers)
    }
    // },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/new/ReportsMixinOld.vue